module.exports = __webpack_public_path__ + "822980941fd98105cc87f7862338cb86.png";